import styled, { css } from 'styled-components';

export const Container = styled.div<{ noHover?: boolean }>`
	display: grid;
	width: 330px;
	height: 70px;
	grid-template-columns: 30px auto 26px;
	background: #f5f7fa;
	border-radius: 6px;
	padding: 16px 12px;
	place-items: center;
	transition: all 0.1s ease-in-out;
	cursor: pointer;

	${({ noHover }) =>
		noHover &&
		css`
			&:hover {
				background: #e6e9ed;
			}
		`}
`;

export const IconContainer = styled.div<{ open?: boolean }>`
	transition: all 0.2s ease-in-out;
	transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const Title = styled.p`
	font-family: 'Montserrat', 'Arial', sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	display: flex;
	align-items: center;
	color: #64778f;
`;

export const Subtitle = styled.p`
	font-family: 'Montserrat';
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	color: #64778f;
`;

export const ImageContainer = styled.div`
	width: 30px;
	height: 32px;
`;

export const SkeletonInfoContainer = styled.div`
	margin-left: 8px;
	width: 100%;
	max-width: 250px;

	& > div {
		margin-bottom: 4px;
	}
`;

export const InfoContainer = styled.div`
	margin-left: 6px;
	width: 100%;
	max-width: 250px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;
